import React from 'react';
import { COLORS } from '../../../styles/tokens';
import { fieldLabelStyle } from './IconField';
import NewOrderIcon from './NewOrderIcon';
import {
  HALF_HOUR_TIMES, splitLocal, joinLocal, nextHalfHourLocal, toLocalInput, formatDateNb,
} from '../../../utils/halfHour';

const overlay = { position: 'absolute', inset: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer', border: 'none', fontSize: 16 };

// Dato + klokkeslett i designets feltstil («Fredag 3. okt · 08:00»).
// Klokkeslett kan bare velges på hele og halve timer; verdien er lokal «YYYY-MM-DDTHH:mm».
export default function HalfHourTimeSelect({ id, label, icon = 'calendar', value, onChange, now }) {
  const current = now ?? new Date();
  const { date, time } = splitLocal(value);
  const today = toLocalInput(current).slice(0, 10);
  const nowTime = toLocalInput(current).slice(11, 16);

  function handleDate(e) {
    const d = e.target.value;
    if (!d) { onChange(''); return; }
    onChange(joinLocal(d, time || splitLocal(nextHalfHourLocal(current)).time));
  }
  function handleTime(e) {
    onChange(joinLocal(date || today, e.target.value));
  }
  function openPicker(e) {
    try { e.target.showPicker?.(); } catch { /* ikke støttet */ }
  }

  return (
    <div>
      <span style={fieldLabelStyle}>{label}</span>
      <div style={styles.box}>
        <span style={{ color: COLORS.brandPanel, display: 'flex' }}><NewOrderIcon name={icon} size={19} /></span>

        <div style={{ ...styles.part, flex: 1 }}>
          <span style={styles.text}>{formatDateNb(value) || 'Velg dato'}</span>
          <input
            id={id}
            type="date"
            aria-label={`${label}, dato`}
            value={date}
            min={today}
            onChange={handleDate}
            onClick={openPicker}
            style={overlay}
          />
        </div>

        <div style={{ ...styles.part, ...styles.timePill }}>
          <span style={styles.text}>{time || '––:––'}</span>
          <select
            aria-label={`${label}, klokkeslett`}
            value={HALF_HOUR_TIMES.includes(time) ? time : ''}
            onChange={handleTime}
            style={overlay}
          >
            {!HALF_HOUR_TIMES.includes(time) && <option value="" disabled>Velg tid</option>}
            {HALF_HOUR_TIMES.map(t => (
              <option key={t} value={t} disabled={(date || today) === today && t < nowTime}>{t}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}

const styles = {
  box: {
    height: 52, borderRadius: 14, background: COLORS.white, border: `1px solid ${COLORS.border}`,
    display: 'flex', alignItems: 'center', gap: 10, padding: '0 8px 0 14px', boxSizing: 'border-box',
  },
  part: { position: 'relative', display: 'flex', alignItems: 'center', height: '100%' },
  text: { fontSize: 15.5, fontWeight: 600, color: COLORS.textDark, whiteSpace: 'nowrap' },
  timePill: { background: COLORS.surfaceHover, borderRadius: 99, height: 36, padding: '0 14px' },
};
